import { useEffect, useRef, useState } from "react";

interface UseClearFiltersModalProps {
  activeFiltersCount: number;
  clearAllFilters: () => void;
  initialShowFilters?: boolean;
}

export function useClearFiltersModal({
  clearAllFilters,
  activeFiltersCount,
  initialShowFilters,
}: UseClearFiltersModalProps) {
  const filterButtonRef = useRef<HTMLButtonElement>(null);
  const [showFilters, setShowFilters] = useState<boolean>(
    () => initialShowFilters ?? activeFiltersCount > 0
  );
  const [showFiltersModal, setShowFiltersModal] = useState<boolean>(false);

  useEffect(() => {
    if (activeFiltersCount > 0) {
      setShowFilters(true);
    }
  }, [activeFiltersCount]);

  const handleToggleFilters = () => {
    if (!showFilters) {
      setShowFilters(true);
      return;
    }

    if (activeFiltersCount > 0) {
      setShowFiltersModal(true);
      return;
    }

    setShowFilters(false);
  };

  const handleClearFilters = () => {
    clearAllFilters();
    setShowFilters(false);
    setShowFiltersModal(false);
  };

  return {
    filterButtonRef,
    showFilters,
    setShowFilters,
    showFiltersModal,
    setShowFiltersModal,
    handleToggleFilters,
    handleClearFilters,
  };
}
